import { Switch, Route } from 'react-router';
import React from 'react';
import { useIdentifyUser } from '@helpers/useIdentifyUser';

import Quiz from './views/Quiz';
import Reload from './views/Reload';
import MyProfile from './views/MyProfile';
// import Project from './views/Project';
import SubmitIdea from './views/SubmitIdea';

const Routes = () => {
  useIdentifyUser();

  return (
    <Switch>
      <Route path={['/profile', '/hackathons', '/settings']} component={Reload} />
      <Route
        exact
        path={['/badges', '/quiz/sample', '/quiz/start', '/quiz/end', '/signin', '/projects']}
        component={Reload}
      />
      <Route exact path="/(@):username" component={MyProfile} />
      {/** This route is not needed anymore because the project page is now handled
       * by the v2 app.
       */}
      {/* <Route exact path="/projects/:projectSlug" component={Project} /> */}
      <Route exact path="/idea/submit" component={SubmitIdea} />

      <Route exact path="/quiz" component={Quiz} />
    </Switch>
  );
};

export default Routes;
